var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 185,
    viewBox: "0 0 263 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12461_208877)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "#111213"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_12461_208877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1323 73.0686L94.7441 65.6181C94.5524 64.5891 95.2311 63.5996 96.26 63.4079L113.565 60.1837C114.059 60.0917 114.569 60.1994 114.983 60.483L122.079 65.3418C122.494 65.6261 122.779 66.0637 122.871 66.5584L127.138 89.4618C127.33 90.4907 126.651 91.4802 125.622 91.6719L102.335 96.0109C101.306 96.2026 100.316 95.5239 100.124 94.495L99.4299 90.7673C98.401 90.959 97.4107 90.2805 97.219 89.2516L94.6156 75.2788C94.4239 74.2499 95.1034 73.2603 96.1323 73.0686ZM126.207 89.6354C126.303 90.1498 125.963 90.6446 125.449 90.7404L102.161 95.0794C101.647 95.1753 101.152 94.8359 101.056 94.3214L100.361 90.5938L113.402 88.1641C114.431 87.9724 115.109 86.9829 114.918 85.9539L112.314 71.9812C112.123 70.9523 111.133 70.2736 110.104 70.4653L97.0638 72.895L95.6756 65.4445C95.5798 64.93 95.9191 64.4353 96.4336 64.3394L112.646 61.3187C113.161 61.2228 113.656 61.5622 113.751 62.0766L114.547 66.3461C114.739 67.375 115.728 68.0537 116.757 67.862L121.038 67.0644C121.552 66.9686 122.047 67.3079 122.143 67.8224L126.207 89.6354ZM114.434 61.2556L114.447 61.2649L121.543 66.1236L121.555 66.1318C121.333 66.0908 121.099 66.0891 120.864 66.1329L116.584 66.9305C116.069 67.0263 115.574 66.687 115.478 66.1725L114.683 61.9031C114.639 61.6666 114.553 61.4487 114.434 61.2556ZM96.3051 74.0002L110.278 71.3968C110.792 71.301 111.287 71.6403 111.383 72.1548L113.986 86.1275C114.082 86.642 113.743 87.1367 113.228 87.2326L99.2556 89.836C98.7411 89.9318 98.2464 89.5925 98.1505 89.078L95.5471 75.1053C95.4513 74.5908 95.7906 74.0961 96.3051 74.0002Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.972 85.1269L103.641 84.8159L104.968 81.8391L107.308 84.1328L108.992 83.819C108.451 83.3183 106.214 81.1597 105.673 80.659L107.567 76.6667L105.912 76.975L104.653 79.8159L102.425 77.6248L100.726 77.9413L103.959 80.9783L101.972 85.1269Z",
    fill: "#F7F8F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_12461_208877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.494 8.6079C110.598 8.6761 109.895 9.3571 109.765 10.209C109.74 10.3055 109.731 10.4088 109.739 10.517L110.899 25.7583C110.978 26.8019 111.889 27.5836 112.932 27.5041L117.657 27.1446C117.633 26.8246 117.629 26.5077 117.644 26.1952L112.86 26.5593C112.371 26.5965 111.941 26.2554 111.856 25.7827C111.85 25.7511 111.846 25.719 111.844 25.6864L110.693 10.5694C110.69 10.529 110.69 10.489 110.691 10.4495L122.891 17.3063C123.921 17.885 125.201 17.7668 126.107 17.0094L136.198 8.57535C136.2 8.59214 136.202 8.60908 136.203 8.62616L136.203 8.62795L137.354 23.7449C137.393 24.2667 137.002 24.7219 136.481 24.7616L132.643 25.0537C132.705 25.3603 132.749 25.6741 132.774 25.9941L136.553 25.7065C137.596 25.6271 138.378 24.7166 138.298 23.673L137.144 8.5023C137.14 8.45495 137.133 8.40906 137.124 8.36476C136.955 7.41866 136.093 6.73574 135.114 6.81023L111.494 8.6079ZM123.355 16.4803L111.208 9.65287C111.316 9.59765 111.437 9.56251 111.566 9.55271L135.186 7.75504C135.34 7.74338 135.487 7.76887 135.62 7.82393C135.61 7.83145 135.601 7.8392 135.591 7.84718L125.499 16.2823C124.895 16.7873 124.042 16.8661 123.355 16.4803Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23 28.662C129.802 28.5423 130.975 26.7654 130.803 24.513C130.588 21.6861 128.084 19.748 125.015 19.9816C121.826 20.2243 119.333 22.8316 119.6 26.3387C119.861 29.7703 122.546 31.8922 126.084 31.623C127.384 31.524 128.887 30.8927 129.7 29.9945L129.018 29.2254C128.166 30.02 127.103 30.4355 126 30.5194C122.976 30.7495 121.042 28.905 120.84 26.2595C120.621 23.3722 122.454 21.2865 125.114 21.084C127.669 20.8895 129.473 22.4096 129.641 24.6167C129.756 26.1284 129.073 27.5487 128.227 27.6132C127.803 27.6454 127.631 27.3848 127.605 27.0371C127.595 26.901 127.599 26.7638 127.618 26.6103L128.146 22.7539L126.951 22.8447L126.876 23.6563C126.598 22.9933 125.818 22.7334 125.183 22.7817C123.55 22.9059 122.273 24.5084 122.427 26.534C122.546 28.0911 123.577 29.0466 124.937 28.943C125.587 28.8935 126.256 28.4929 126.66 27.8084C126.877 28.4609 127.52 28.7161 128.23 28.662ZM126.662 25.2387C126.725 26.6631 126.093 27.7451 125.065 27.8234C124.082 27.8982 123.725 27.1955 123.654 26.2734C123.569 25.1548 124.196 23.9971 125.284 23.9143C126.101 23.8522 126.594 24.3468 126.662 25.2387Z",
    fill: "#F7F8F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_12461_208877)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_12461_208877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.551 71.0149C167.369 72.0455 166.386 72.7335 165.355 72.5515L142.028 68.4316C140.997 68.2496 140.309 67.2665 140.491 66.2358L145.6 37.3096C145.782 36.2789 146.765 35.5909 147.795 35.7729L165.13 38.8344C165.624 38.9217 166.064 39.2017 166.352 39.6128L171.288 46.6549C171.577 47.0669 171.69 47.5768 171.603 48.0723L167.551 71.0149ZM166.618 70.8501C166.527 71.3654 166.035 71.7094 165.52 71.6184L142.192 67.4985C141.677 67.4075 141.333 66.9159 141.424 66.4006L146.533 37.4744C146.624 36.959 147.115 36.615 147.631 36.7061L163.871 39.5743C164.386 39.6653 164.73 40.1568 164.639 40.6722L163.884 44.9489C163.702 45.9796 164.39 46.9627 165.421 47.1447L169.709 47.902C170.224 47.993 170.568 48.4845 170.477 48.9999L166.618 70.8501ZM165.567 40.1431C165.57 40.1476 165.573 40.1521 165.576 40.1567L170.513 47.1988C170.515 47.2027 170.518 47.2067 170.521 47.2106C170.327 47.0941 170.109 47.0105 169.873 46.9689L165.585 46.2116C165.07 46.1206 164.726 45.629 164.817 45.1137L165.572 40.837C165.614 40.6001 165.61 40.3658 165.567 40.1431Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.418 55.5256L154.477 55.1828L150.81 57.8144L152.012 51.0064L150.624 50.7612L148.715 61.5703L150.104 61.8155L150.486 59.6507L151.663 58.8271L153.448 62.4062L155.209 62.7173L152.822 58.0158L156.418 55.5256Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.515 63.4777L161.224 53.8033L159.94 53.5765C159.531 54.582 158.474 55.165 157.125 54.9576L156.943 55.9877L159.287 56.4017L158.082 63.2246L159.515 63.4777Z",
    fill: "#F7F8F9"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_12461_208877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.25 127.04L107.25 120V145.08L129.25 152.12V127.04ZM134.75 127.04V152.12L156.75 145.08V120L134.75 127.04Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.25 118.375L133.5 111.5L139.5 109.5L162.5 116.5L156.25 118.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 117.5L131.5 111.5L125.5 109.5L102 115.5L108 117.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 104.5,
    x2: 164,
    y2: 104.5,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 104.5,
    x2: 164,
    y2: 104.5,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 104.5,
    x2: 164,
    y2: 104.5,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5,
    y1: 109,
    x2: 159.5,
    y2: 100,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5,
    y1: 109,
    x2: 159.5,
    y2: 100,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5,
    y1: 109,
    x2: 159.5,
    y2: 100,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 49.5,
    x2: 93,
    y2: 49.5,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 49.5,
    x2: 93,
    y2: 49.5,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 49.5,
    x2: 93,
    y2: 49.5,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.5,
    y1: 54,
    x2: 88.5,
    y2: 45,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.5,
    y1: 54,
    x2: 88.5,
    y2: 45,
    stroke: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.5,
    y1: 54,
    x2: 88.5,
    y2: 45,
    stroke: "#FFF8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12461_208877",
    x: 78.4477,
    y: 47.4131,
    width: 61.9381,
    height: 61.9379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.482811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12461_208877",
    result: "effect2_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_208877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_12461_208877",
    x: 95.8569,
    y: -8.17776,
    width: 57.8737,
    height: 57.8737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.482811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12461_208877",
    result: "effect2_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_208877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_12461_208877",
    x: 125.989,
    y: 23.955,
    width: 61.6081,
    height: 61.6085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.482811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12461_208877",
    result: "effect2_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_208877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_12461_208877",
    x: 125.989,
    y: 23.9555,
    width: 61.6081,
    height: 61.6081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.482811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.965621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12461_208877",
    result: "effect2_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_208877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_12461_208877",
    x: 71.25,
    y: 86,
    width: 121.5,
    height: 104.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_208877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_208877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12461_208877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicBox);
export default __webpack_public_path__ + "static/media/magic-box.8b05e1f7a3711d2df43c5dc97a32c020.svg";
export { ForwardRef as ReactComponent };